const apiUrl = process.env.REACT_APP_API_URL;
export const CopyAulaModal = async (id_aula: string, aules: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/copy`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ aules })
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
